export const FieldType = Object.freeze({
  TEXT: "text",
  DATETIME: "datetime",
  SELECT: "select", // frontend only
  NUMBER_INTEGER: "numberInteger", // frontend only
});
